<template>
  <div class="subscription-flow" v-if="!asyncLoading">
    <!--We use v-show and not v-if because the credit-card component cannot be re-rendered-->
    <!--The fields in it are mounted by payme making rerendering heavy and destroying previous context-->
    <template v-if="onPersonalInfoStep || onCreditCardStep">
      <personal-info v-show="onPersonalInfoStep" :next="moveToCreditCardStep" :back="moveBackToCashflow"/>
      <credit-card v-show="onCreditCardStep" :next="createSubscription" :back="moveToPersonalInfoStep"/>
    </template>
    <template v-else>
      <done v-show="onDone"/>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PersonalInfo from './pages/PersonalInfo.vue';
import CreditCard from './pages/CreditCard.vue';
import Done from './pages/Done.vue';
import Segment from '../../../../Segment';
import router from '../../../../router';

export default {
  name: 'SubscriptionFlow',
  components: {
    PersonalInfo,
    CreditCard,
    Done,
  },
  data() {
    return {
      asyncLoading: true,
    };
  },
  async created() {
    Segment.trackUserGot('SubscriptionEntered');
    await this.init();
    this.asyncLoading = false;
  },
  computed: {
    ...mapGetters('subscription', ['onPersonalInfoStep', 'onCreditCardStep', 'onDone']),
  },
  methods: {
    ...mapActions('subscription', ['init', 'moveToPersonalInfoStep', 'moveToCreditCardStep', 'createSubscription']),
    moveBackToCashflow() {
      Segment.trackUserInteraction('SubscriptionMoveBackToCashflow');
      router.push({ path: '/home' });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../scss/mixins';

  .subscription-flow {
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/subscription/SubscriptionFlow.vue